import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'school-logo-ui',
  templateUrl: './logo-ui.component.html',
  styleUrls: ['./logo-ui.component.scss']
})
export class LogouiComponent implements OnInit {

  @Input() brandpath: any;
  headerLogo = '';
  constructor() { }

  ngOnInit(): void {
    this.headerLogo = this.brandpath;
  }

  

}
